export default {
    variable: 'name',
    placeholder: 'Dein Vor- und Nachname',
    iconSet: "emoji",
    iconType: "wave",
    iconName: "🙂",
    type: 'text',
    style: { backgroundColor: null, color: null, }
}
